export const environment = {
  production: true,
  base_url: 'https://vmi1821173.contaboserver.net/job/api',
  imagenUrl: 'https://vmi1821173.contaboserver.net/job/api',
  URL_SERVICIOS :'https://jobandcare.com'

};
